const SERVICE_ID = 'service_pomvvx7';
const TEMPLATE_ID = 'template_fydzjh4';
const USER_ID = '9JFl8KJThjUmZ-K_7';

const githubURL = 'https://github.com/97Fakhreddine';
const facebookURL = 'https://www.facebook.com/Fakhri.Shaarawy';
const instagramURL = 'https://www.instagram.com/fakhreddine_messaoudi';
const linkedInURL = 'https://www.linkedin.com/in/97fakhreddine/';

module.exports = {
  SERVICE_ID,
  TEMPLATE_ID,
  USER_ID,
  githubURL,
  facebookURL,
  instagramURL,
  linkedInURL,
};
